import { styled } from '@mui/material/styles';
import { Typography, Select, ListItemText, Button, FormControlLabel, Grid } from '@mui/material';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '10.89px',
  lineHeight: '13.35px',
  marginRight: '5px',
  color: theme.palette.text.primary,
}));

export const StyledSelect = styled(Select)(() => ({
  height: '23px',
  borderRadius: '3.81px',
  fontSize: '9px',
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '9px !important',
  lineHeight: '13.35px !important',
  padding: 0,
  '& .MuiTypography-root': {
    fontSize: '9px !important',
    color: theme.palette.text.primary,
    padding: 0,
    paddingTop: '4px',
  },
  height: '20px',
}));

export const DropdDownGrid = styled(Grid)(() => ({
  height: '229px',
  overflowY: 'auto',
}));

export const DropdownContainer = styled('div')(() => ({
  position: 'relative',
  maxHeight: '297px',
  overflow: 'none',
  borderRadius: '10px',
}));

export const ClearButton = styled(Button)(() => ({
  border: 'none',
  fontSize: '8px',
  lineHeight: '13.35px',
  marginTop: '3px',
  marginRight: '5px',
  background: 'white',
  color: '#DF2020',
  cursor: 'pointer',
  '&:hover': {
    background: '#f0f0f0',
    color: '#B71C1C',
  },
}));

export const SelectAllToggle = styled(FormControlLabel)(({ theme }) => ({
  position: 'absolute',
  top: '5px',
  left: '5px',
  zIndex: 1000,
  background: 'white',
  textAlign: 'left',
  '& .MuiFormControlLabel-label': {
    fontSize: '9px !important',
    color: theme.palette.text.primary,
  },
}));

export const BrandMenuContainer = styled(Grid)(() => ({
  height: '161px',
}));

export const MenuContainer = styled('div')(() => ({
  overflowY: 'hidden',
  '&:hover': {
    overflowY: ' auto',
  },
}));

export const SelectAllContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 10px',
  marginBottom: '10px',
  marginTop: '4px',
}));
